(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("deviceapis", [], factory);
	else if(typeof exports === 'object')
		exports["deviceapis"] = factory();
	else
		root["deviceapis"] = factory();
})(this, () => {
return 